module.exports = __webpack_public_path__ + "img/pos-facilities.08e2505d.png";